import React, { useState } from 'react';
import moment from 'moment-timezone';
import _ from 'underscore';

import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';

import RegisterKid from './RegisterKid';

import { HorizontallyCenteringContainer, VerticalSeparator } from './utils';

import { setCommunicationsOptions, updateMemberProfile } from './utils';
import { parseDateTimestampString } from './utils';

export default function UpdateProfileAndAddChildButtons({ token, memberData, updateMemberData }) {
    /*
    Cross-capability UI surface:
    - CAP-MEMBER-SELF-SERVICE: profile/preferences editing
    - CAP-MEMBER-FAMILY-MANAGEMENT: child-registration modal launch
    */
    const hasPreviouslyChangedDOB = (memberData?.MemberInfo?.FaxNo || '').split('|').filter(s => s.startsWith('LastDOBChangeTS=')).length > 0;

    const [showPreferencesModal, setShowPreferencesModal] = useState(false);
    // CAP-MEMBER-SELF-SERVICE: profile and communications-preferences modal

    const [newName, setNewName] = useState(memberData?.MemberInfo?.Name);
    const [newMobileNo, setNewMobileNo] = useState(memberData?.MemberInfo?.MobileNo);
    const [newMobileNoErrorText, setNewMobileNoError] = useState(null);
    const [newDOB, setNewDOB] = useState(memberData?.MemberInfo?.DOB && parseDateTimestampString(memberData?.MemberInfo?.DOB) && moment(parseDateTimestampString(memberData?.MemberInfo?.DOB).getTime()).tz('Asia/Shanghai').format('YYYY-MM-DD'));
    const [newDOBErrorText, setNewDOBError] = useState(null);
    const [inputsAreValid, setInputsAreValid] = useState(false);
    const [isUpdatingProfile, setIsUpdatingProfile] = useState(false);
    const [updateProfileFormResult, setUpdateProfileFormResult] = useState(null);
    const [updateProfileFormError, setUpdateProfileFormError] = useState(null);

    function validateInputs({ type, newValue }) {
        // CAP-MEMBER-SELF-SERVICE frontend validation mirrors the current
        // backend constraints for mobile format and DOB plausibility.
        let allValid = true;

        // const re2 = new RegExp(/^(\+[0-9]+\s{0,1}|)[0-9]{8,}$/);
        const re2 = new RegExp(/^[0-9]{8}$/);
        if(!re2.test(type === 'newMobileNo' ? newValue : newMobileNo)) {
            setNewMobileNoError('Please enter a valid mobile number. (e.g.: 91234567)')
            allValid = false;
        } else {
            setNewMobileNoError(null);
        }
        
        const dob = type === 'newDOB' ? newValue : newDOB;
        if(!dob || !Number.isFinite((new Date(dob)).getTime()) || !((new Date(dob)).getTime() >= -2209013725000) || !((new Date(dob)) < new Date())) {
            setNewDOBError('Please enter a valid date of birth.')
            allValid = false;
        } else {
            setNewDOBError(null);
        }
        
        setInputsAreValid(allValid);
    }

    const [isUpdatingCommunicationsOptions, setIsUpdatingCommunicationsOptions] = useState(false);
    function closePreferencesModal() {
        setShowPreferencesModal(false);
        setIsUpdatingCommunicationsOptions(false);
    }

    const [showRegisterKidModal, setShowRegisterKidModal] = useState(false);
    function closeRegisterKidModal() {
        setShowRegisterKidModal(false);
    }

    return (
        <>
            <HorizontallyCenteringContainer additionalStyles={{ height: '3em' }}>
                <Button onClick={() => setShowPreferencesModal(true)} className="w50 swensens-button">
                    ⚙️ Profile
                </Button>
                &nbsp; &nbsp;
                <Button onClick={() => setShowRegisterKidModal(true)} className="w50 swensens-button">
                    👨‍👩‍👧‍👦 Add Child
                </Button>
            </HorizontallyCenteringContainer>
            <Modal
                show={showPreferencesModal} fullscreen={true}
                onHide={closePreferencesModal}
            >
                <div style={{
                    height: 'calc(20px)',
                    backgroundColor: 'var(--app-top-strip-color)'
                }} />
                <Modal.Header closeButton>
                    <span className="voucher-redeem-header">Edit Preferences</span>
                </Modal.Header>
                <Modal.Body>
                    <HorizontallyCenteringContainer>
                        <p className="app-text">
                            <strong>Particulars:</strong>
                        </p>
                    </HorizontallyCenteringContainer>
                    <div>Name:</div>
                    <HorizontallyCenteringContainer>
                        <input disabled={isUpdatingProfile}
                            className="underline-input"
                            value={newName}
                            onChange={e => {
                                setNewName(e.target.value);
                                validateInputs({ type: 'newName', newValue: e.target.value });
                            } } />
                    </HorizontallyCenteringContainer>
                    <VerticalSeparator height='0.5em' />

                    <div>Email:</div>
                    <HorizontallyCenteringContainer>
                        <input disabled={true}
                            className="underline-input"
                            value={memberData?.MemberInfo?.Email} />
                    </HorizontallyCenteringContainer>

                    <VerticalSeparator height='0.5em' />

                    <div>Mobile Number:</div>
                    <HorizontallyCenteringContainer>
                        <input disabled={isUpdatingProfile}
                            type="tel" pattern="[0-9]{8}" className="underline-input"
                            value={newMobileNo}
                            onChange={e => {
                                setNewMobileNo(e.target.value);
                                validateInputs({ type: 'newMobileNo', newValue: e.target.value });
                            } } />
                    </HorizontallyCenteringContainer>
                    {newMobileNoErrorText && (
                        <>
                            <HorizontallyCenteringContainer>
                                <div className="input-error">{newMobileNoErrorText}</div>
                            </HorizontallyCenteringContainer>
                            <VerticalSeparator />
                        </>
                    )}
                    <VerticalSeparator height='0.5em' />

                    {hasPreviouslyChangedDOB ? (
                        <>
                            <div>Date of Birth (allowed changes expended):</div>
                            <input
                                disabled={true}
                                type="date" className="underline-input"
                                value={newDOB} />
                        </>
                    ) : (
                        <>
                            <div>Date of Birth (up to 1 change):</div>
                            <HorizontallyCenteringContainer>
                                <input disabled={isUpdatingProfile}
                                    type="date" className="underline-input"
                                    value={newDOB}
                                    onChange={e => {
                                        setNewDOB(e.target.value);
                                        validateInputs({ type: 'newDOB', newValue: e.target.value });
                                    } } />
                            </HorizontallyCenteringContainer>
                            {newDOBErrorText && (
                                <>
                                    <HorizontallyCenteringContainer>
                                        <div className="input-error">{newDOBErrorText}</div>
                                    </HorizontallyCenteringContainer>
                                    <VerticalSeparator />
                                </>
                            )}
                        </>
                    )}

                    <VerticalSeparator height='1em' />
                    <HorizontallyCenteringContainer>
                        <Button
                            disabled={isUpdatingProfile || !inputsAreValid}
                            onClick={() => {
                                setIsUpdatingProfile(true);
                                setUpdateProfileFormError(null);
                                setUpdateProfileFormResult(null);
                                updateMemberProfile({ token, newName, newMobileNo, newDOB })
                                    .then((r) => {
                                        if (r.data.success) {
                                            setUpdateProfileFormResult('Done.');
                                            updateMemberData();
                                        } else {
                                            setUpdateProfileFormError(r.data.message);
                                        }
                                    })
                                    .catch(() => {
                                        setUpdateProfileFormError('Error updating profile. Try again later.');
                                    })
                                    .then(() => {
                                        setIsUpdatingProfile(false);
                                    });
                            } }
                            className="w50 swensens-button"
                        >
                            Update Profile
                        </Button>
                    </HorizontallyCenteringContainer>
                    {updateProfileFormResult && (
                        <>
                            <HorizontallyCenteringContainer>
                                <div className="form-result">{updateProfileFormResult}</div>
                            </HorizontallyCenteringContainer>
                            <VerticalSeparator />
                        </>
                    )}
                    {updateProfileFormError && (
                        <>
                            <HorizontallyCenteringContainer>
                                <div className="input-error">{updateProfileFormError}</div>
                            </HorizontallyCenteringContainer>
                            <VerticalSeparator />
                        </>
                    )}


                    <VerticalSeparator height='2em' />

                    <HorizontallyCenteringContainer>
                        <p className="app-text">
                            <strong>Allowed Communications Options:</strong>
                        </p>
                    </HorizontallyCenteringContainer>
                    <HorizontallyCenteringContainer>
                        <div style={{ maxWidth: '95%' }}>
                            {[
                                { label: 'Instant Messenger Services (Telegram)', jsField: 'allowInstantMessengerServices', backendField: 'allow_instant_messenger_services' },
                                { label: 'Email', jsField: 'allowEmail', backendField: 'allow_email' },
                                { label: 'SMS', jsField: 'allowSMS', backendField: 'allow_sms' },
                            ].map(d => (
                                <div key={`form-checks-${d.label}`}>
                                    <Form.Check
                                        type="checkbox" label={d.label}
                                        {...({ checked: !!memberData?.__member_record__?.communication_options?.[d.backendField] })}
                                        {...(isUpdatingCommunicationsOptions ? { disabled: true } : {})}
                                        onChange={e => {
                                            const communicationOptions = {
                                                allowSMS: memberData?.__member_record__?.communication_options?.allow_sms || false,
                                                allowEmail: memberData?.__member_record__?.communication_options?.allow_email || false,
                                                allowInstantMessengerServices: memberData?.__member_record__?.communication_options?.allow_instant_messenger_services || false
                                            };
                                            communicationOptions[d.jsField] = e.target.checked;
                                            setIsUpdatingCommunicationsOptions(true);
                                            setCommunicationsOptions(_.extend({ token }, communicationOptions))
                                                .then(() => updateMemberData())
                                                .catch(e => console.error('Error updating communications options:', e))
                                                .then(() => {
                                                    setIsUpdatingCommunicationsOptions(false);
                                                });

                                        } } />
                                </div>
                            ))}
                        </div>
                    </HorizontallyCenteringContainer>
                </Modal.Body>
            </Modal>

            <Modal
                show={showRegisterKidModal} fullscreen={true}
                onHide={closeRegisterKidModal}
            >
                <div style={{
                    height: 'calc(20px)',
                    backgroundColor: 'var(--app-top-strip-color)'
                }} />
                <Modal.Header closeButton>
                    <span className="voucher-redeem-header">Sign Up for Cool Rewards Junior Membership</span>
                </Modal.Header>
                <Modal.Body>
                    <RegisterKid
                        token={token}
                        closeModal={closeRegisterKidModal}
                        updateMemberData={updateMemberData} />
                </Modal.Body>
            </Modal>
        </>
    );
}
